import { render, staticRenderFns } from "./StatisticSynthesis.vue?vue&type=template&id=7bada058&scoped=true&"
import script from "./StatisticSynthesis.vue?vue&type=script&lang=ts&"
export * from "./StatisticSynthesis.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticSynthesis.vue?vue&type=style&index=0&id=7bada058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bada058",
  null
  
)

export default component.exports